import React from 'react';

export const CircleQuarterTopLeft = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        {...props}
    >
        <path
            d="M0 16.5h2.57C2.57 9.083 8.583 3.07 16 3.07V.5C7.17.513.013 7.67 0 16.5z"
            fill="currentColor"
        />
    </svg>
);
